var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 27C18.5625 27 17 28.625 17 30.5C17 32.4375 18.5625 34 20.4375 34C22.3125 34 24 32.4375 24 30.5C24 28.625 22.375 27 20.4375 27ZM40 13.4375C35.0625 8.75 27.9375 6 20.5 6C13 6 5.875 8.75 0.937503 13.4375C0.312503 14 0.312503 14.9375 0.875003 15.5625C1.4375 16.1875 2.375 16.1875 3 15.625C7.375 11.4375 13.75 9 20.5 9C27.1875 9 33.5625 11.4375 37.9375 15.625C38.25 15.875 38.625 16 38.9375 16C39.3125 16 39.6875 15.875 40 15.5625C40.625 14.9375 40.625 14 40 13.4375ZM20.5 17C15.6875 17 11.25 18.75 7.9375 21.9375C7.3125 22.5 7.3125 23.5 7.875 24.0625C8.4375 24.6875 9.4375 24.6875 10 24.125C12.75 21.5 16.4375 20 20.5 20C24.5 20 28.1875 21.5 30.9375 24.125C31.25 24.375 31.5625 24.5 31.9375 24.5C32.3125 24.5 32.6875 24.375 33 24.0625C33.5625 23.5 33.5625 22.5 32.9375 21.9375C29.6875 18.75 25.25 17 20.5 17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.ae4cd09a84c46eb95adb9f3014fb94ec.svg";
export { ForwardRef as ReactComponent };